import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps} from 'packages/common-types/base-types';
import {Divider} from '@material-ui/core';

type Props = DialogProps & {
  supports: {
    tournamentData: {
      name: string;
      startDate: string;
      finishDate: string;
      address: {
        country: string;
        state: string;
        city: string;
      };
      conditions: {
        gender: string;
        numberOfRounds: number;
        tournamentType: string;
        modalityGame: string;
        pointLimit: number;
        tournamentCategory: string;
      };
    };
    stats: {
      place: number;
      matchesWon: number;
      matchesLose: number;
      matchDifference: number;
      pointsAgainst: number;
      pointsInFavor: number;
      pointDifference: number;
    };
    rankingObtained: number;
  }[];
};

export default function NationalStandingByUser(props: Props) {
  const {modalOpen, toggle, supports} = props;

  return (
    <Dialog
      open={modalOpen}
      scroll="paper"
      keepMounted={false}
      onClose={toggle}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="create-tournament-dialog-title">
        Ranking Nacional
      </DialogTitle>
      <DialogContent dividers>
        {supports?.map(({tournamentData, stats, rankingObtained}, index) => {
          const startDate = new Date(Number(tournamentData?.startDate));
          const endDate = new Date(Number(tournamentData?.finishDate));
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index}>
              <h2>{tournamentData.name}</h2>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div style={{display: 'flex'}}>
                  <div>
                    <p style={{fontSize: '15px'}}>
                      <b>Fecha de inicio:</b>{' '}
                      {startDate.toString().substr(4, 11)}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Fecha de finalización:</b>{' '}
                      {endDate.toString().substr(4, 11)}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Lugar:</b>
                      {`${tournamentData.address.country},${tournamentData.address.state},${tournamentData.address.city}`}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Condiciones:</b>
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Genero:</b> {tournamentData.conditions.gender}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Numero de rondas:</b>{' '}
                      {tournamentData.conditions.numberOfRounds}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Tipo:</b> {tournamentData.conditions.tournamentType}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Categoria:</b>
                      {tournamentData.conditions.tournamentCategory}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Modalidad:</b> {tournamentData.conditions.modalityGame}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Pintas:</b> {tournamentData.conditions.pointLimit}
                    </p>
                  </div>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{marginRight: '20px', marginLeft: '20px'}}
                  />
                  <div>
                    <p style={{fontSize: '15px'}}>
                      <b>Posición:</b> {stats.place + 1}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Partidas ganadas:</b> {stats.matchesWon}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Partidas perdidas:</b> {stats.matchesLose}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Efectividad de partidas:</b> {stats.matchDifference}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Puntos a favor:</b> {stats.pointsInFavor}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Puntos en contra:</b> {stats.pointsAgainst}
                    </p>
                    <p style={{fontSize: '15px'}}>
                      <b>Efectividad de puntos:</b> {stats.pointDifference}
                    </p>
                  </div>
                </div>
                <p style={{fontSize: '15px'}}>
                  <b>Ranking obtenido:</b> {rankingObtained}
                </p>
              </div>
            </div>
          );
        })}
      </DialogContent>
    </Dialog>
  );
}
